
import "./ResultBox.scss";
import { ResultEntry } from "./ResultEntry";

export const ResultBox = (props) => {
  const { data, onResultClick } = props;
  return (
    <div className="shootout-resultbox-root">
      {data.map((entry, idx) => (
        <ResultEntry
          key={`res-${idx}`}
          idx={idx + 1}
          status={entry.status}
          bib={entry.bib}
          isSuccess={entry.isSuccess}
          isEditable={entry.isEditable}
          isSaving={entry.isSaving}
          onClick={() => onResultClick(entry.event)}
        />
      ))}
    </div>
  );
};
